import { Button } from '@/components/ui/daisy';
import { useToggleGroupContext } from '@/components/ui/daisy/toggle-group';
import { twMerge } from 'tailwind-merge';
import { CheckIcon, XMarkIcon } from '@heroicons/react/24/outline';
import { useTranslation } from 'react-i18next';
import { FlashcardAnswerOption } from '../../typologies/flashcard/useFlashcardAnswer';

type FlashcardOptionProps = {
  option: FlashcardAnswerOption;
  disabled: boolean;
};

const flashcardMap = {
  true: {
    color: 'success',
    icon: CheckIcon,
    disabledClass: 'hover:text-success hover:border-success',
  },
  false: {
    color: 'error',
    icon: XMarkIcon,
    disabledClass: 'hover:text-error hover:border-error',
  },
} as const;

export function FlashcardOption({
  option,
  disabled,
}: FlashcardOptionProps) {
  const { value:selectedValue, onItemClick } = useToggleGroupContext();
  const { value } = option;
  const { t } = useTranslation('translation', {
    keyPrefix: 'questionView.flashcard',
  });

  const { color, icon: Icon, disabledClass } = flashcardMap[value];

  return (
    <Button
      type="button"
      color={color}
      variant={!disabled && selectedValue === value ? 'default': 'soft'}
      size="sm"
      shape="block"
      aria-pressed={selectedValue === value}
      onClick={() => onItemClick(value)}
      value={value}
      className={twMerge(
        'w-38',
        disabled && `hover:bg-transparent hover:shadow-none ${disabledClass}`,
      )}
    >
      <div className="flex gap-2 items-center">
        <Icon className="size-5" />
        {t(value)}
      </div>
    </Button>
  );
}
